import React from "react";
import { Destination } from "../../../../../../../../models/Entities";
import DestinationButton from "./DestinationButton";

type DestinationListProps = {
  destinations: Destination[];
  onDestinationSelect: (destination: Destination) => void;
};

const DestinationList = ({ destinations, onDestinationSelect }: DestinationListProps) => {
  return (
    <div className="flex flex-col overflow-y-auto scrollbar-hide">
      <div className="grid grid-cols-3 gap-3 px-5 pt-4">
        {destinations.map((destination) => (
          <DestinationButton
            key={destination.id}
            destination={destination}
            onClick={() => onDestinationSelect(destination)}
          />
        ))}
      </div>

      {/* forces 20px spacing after overflow grid */}
      <div className="h-5" />
    </div>
  );
};

export default DestinationList;
